<script>
  const baseURL = 'http://49.235.82.97:8888/';
  export default {
    baseURL
  }
</script>